<template>
  <div v-if="singleLine">
    <div v-if="datetime">
      <div v-if="!disableTime">
        {{ utc ? getDateTimeUtc() : $dayjs(normalize()).format('D.M.YYYY H:mm') }}
      </div>
      <div v-else>
        {{ $dayjs(normalize()).format('D.M.YYYY') }}
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="datetime">
      {{ $dayjs(normalize()).format('D.M.YYYY') }}
      <br />
      <div v-if="!disableTime">
        {{ utc ? getTimeUtc() : $dayjs(normalize()).format('H:mm') }}
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

const utc = require('dayjs/plugin/utc')

dayjs.extend(utc)

export default {
  name: 'DateTime',
  props: {
    datetime: {
      type: String,
      required: false,
    },
    singleLine: {
      type: Boolean,
      required: false,
    },
    disableTime: {
      type: Boolean,
      required: false,
    },
    utc: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    getTimeUtc() {
      return dayjs.utc(self.normalize()).format('H:mm')
    },
    getDateTimeUtc() {
      return dayjs.utc(self.normalize()).format('D.M.YYYY H:mm')
    },
    normalize() {
      const normalized = this.datetime.replace(/ /g, 'T')
      if (normalized.endsWith('Z')) {
        return normalized
      }
      return normalized + 'Z'
    },
  },
}
</script>
